import React from 'react';
import { snakkerVerbs } from '../../data/ferringConcept';
export function IdeaPanel() {
  return <div data-id="element-77" data-mp="3k3f4eidrzdpj">
      <h2 className="max-w-3xl text-[36px] font-medium leading-[1.04] tracking-[-0.035em] text-navy md:text-[48px]" data-id="element-78" data-mp="3k2vunoya3vml">
        Don't just tell the product story. Let the HCP experience it.
      </h2>
      <p className="mt-6 max-w-2xl text-lg leading-relaxed text-navy/65" data-id="element-79" data-mp="3a6sh7mxz8akc">
        Product benefits in pharma are often communicated through explanation: claims, charts, studies and product detail.{' '}
        <span className="text-navy" data-id="element-80" data-mp="6q28h0b0fjey">Snakker adds another possibility — turn the benefit into something the HCP can do.</span>
      </p>

      <p className="mt-10 text-sm text-navy/45" data-id="element-81" data-mp="1s0omd5rfg2f">A short interaction can let the HCP</p>
      <ol className="mt-3 grid overflow-hidden rounded-xl border border-navy/10 sm:grid-cols-5" data-id="element-82" data-mp="3tt71bj9ckix6">
        {snakkerVerbs.map((v, i) => <li key={v} className={`px-4 py-4 text-base leading-snug text-navy ${i > 0 ? 'border-t border-navy/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-83" data-mp="2iel1qpu7j47j" data-mpi={i}>
            {v}
          </li>)}
      </ol>

      <p className="mt-10 max-w-2xl text-2xl leading-snug tracking-[-0.01em] text-navy" data-id="element-84" data-mp="xh20x9enb9vh">
        The result is a product story that is easier to engage with — and easier to remember.
      </p>
    </div>;
}